export const SET_MESSAGE_IFRAME = "SET_MESSAGE_IFRAME";
export const SET_FULLWIDTH_IFRAME = "SET_FULLWIDTH_IFRAME";
export const SET_STATE_VIDEO_IFRAME = "SET_STATE_VIDEO_IFRAME";
export const SET_MINIMIZE_PLAYLIST_IFRAME = "SET_MINIMIZE_PLAYLIST_IFRAME";
export const SET_TREE_VIDEOS_IFRAME = "SET_TREE_VIDEOS_IFRAME";
export const SET_VIDEO_IFRAME = "SET_VIDEO_IFRAME";
export const SET_MODE_IFRAME = "SET_MODE_IFRAME";
export const SET_SAMPLER = "SET_SAMPLER";
